import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import jobPartiesMixin from './jobPartiesMixin'
import waitForRefreshApplicationMixin from './waitForRefreshApplicationMixin'
import { getJob } from '@/api/jobs/job/job'
import { STAGE_IN_PROGRESS } from '@/constants/job/jobStages'
import snackMixin from '@/mixins/snackMixin'
import Job from '@/models-ts/job/Job'
import { RootState } from '@/store'
import { addDays, isBefore } from '@/utils/date'

const EXTRA_DAYS = 2

export default Vue.extend({
  mixins: [jobPartiesMixin, snackMixin, waitForRefreshApplicationMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.jobChat.application.value,
      returnFundsToCustomerLoading: (state: RootState) => state.jobDetails.returnFundsToCustomerLoading,
    }),
    deadline() {
      return this.application.estimatedDeadline
    },
    refundDate() {
      return addDays(this.deadline, EXTRA_DAYS)
    },
    refundHasCome() {
      return isBefore(this.refundDate, Date.now())
    },
    hasRefund() {
      return this.isEmployer && this.application.job?.stage === STAGE_IN_PROGRESS && this.refundHasCome
    },
    refunding() {
      return this.returnFundsToCustomerLoading[this.application?.job?.id]
    },
  },
  methods: {
    ...mapMutations({
      setReturnFundsToCustomerLoading: 'jobDetails/setReturnFundsToCustomerLoading',
    }),
    ...mapActions({
      runRefund: 'jobDetails/refundToCustomerByCustomerV2',
    }),
    async refundToCustomer() {
      this.setReturnFundsToCustomerLoading({ jobId: this.application?.job?.id })

      let job
      try {
        job = Job.fromServer(await getJob(`${this.application.job.slug}-${this.application.job.id}`))
      } catch (error) {
        this.openSnackbar({
          type: this.SnackTypes.FAILURE,
          text: `Error fetching job details. Please try again.`,
        })
        this.setReturnFundsToCustomerLoading({ jobId: this.application?.job?.id, loading: false })
        throw error
      }

      if (process.env.VUE_APP_MODE === 'dev') {
        this.runRefund({
          job: job,
          successSign: this.waitRefreshApplication,
        })
      } else {
        if (this.refundHasCome) {
          this.runRefund({
            job: job,
            successSign: this.waitRefreshApplication,
          })
        } else {
          this.openSnackbar({
            type: this.SnackTypes.FAILURE,
            text: `You can only initiate a refund 48 hours after the deadline has been reached.`,
          })
        }
      }
    },
  },
})
